import YouTube from 'react-youtube'

import styled from 'styled-components'

import media from '../../util/media'

export const VideoPlay = styled.div`
  position: absolute;
  z-index: 2;
  transition: transform ease 400ms;
`

export const VideoPoster = styled.div`
  cursor: pointer;
  background-image: url(${({ youtubePoster }) => youtubePoster});
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.dark};
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ active }) => (active ? 1 : 0)};
  user-select: ${({ active }) => (active ? 'auto' : 'none')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  transition: all ease 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const VideoYouTube = styled(YouTube)`
  ${media.lessThan('xs')`
    height: 250px;
  `}
`

export const VideoWrapper = styled.div`
  position: relative;

  &:hover {
    ${VideoPlay} {
      transform: scale(1.2);
    }
  }
`
